import { useCallback, useState } from 'react';
import type { LaneDirection } from '../../components/contributions/roadFlowUtils';
import {
  EMPTY_SIDE_FACILITIES,
  type SideFacilityFormState,
} from '../../utils/roadSideFacilities';

/** Motor-road attribute fields (Details step + submit extras). */
export function useRoadDetailsState() {
  const [roadSurface, setRoadSurface] = useState('');
  const [roadSmoothness, setRoadSmoothness] = useState('');
  const [roadCarriagewayCount, setRoadCarriagewayCount] = useState<number | null>(null);
  const [roadLanes, setRoadLanes] = useState('');
  const [roadLanesForward, setRoadLanesForward] = useState('');
  const [roadLanesBackward, setRoadLanesBackward] = useState('');
  const [roadLaneDirections, setRoadLaneDirections] = useState<LaneDirection[]>([]);
  const [roadUsePerLaneWidths, setRoadUsePerLaneWidths] = useState(false);
  const [roadLaneWidthsM, setRoadLaneWidthsM] = useState<string[]>([]);
  const [roadCarriagewayALaneWidthsM, setRoadCarriagewayALaneWidthsM] = useState<string[]>([]);
  const [roadCarriagewayBLaneWidthsM, setRoadCarriagewayBLaneWidthsM] = useState<string[]>([]);
  const [roadManualLaneDirections, setRoadManualLaneDirections] = useState(false);
  const [roadCarriagewayALaneDirections, setRoadCarriagewayALaneDirections] = useState<LaneDirection[]>([]);
  const [roadCarriagewayBLaneDirections, setRoadCarriagewayBLaneDirections] = useState<LaneDirection[]>([]);
  const [roadManualDividedLaneDirections, setRoadManualDividedLaneDirections] = useState(false);
  const [roadToll, setRoadToll] = useState(false);
  const [roadFloodProne, setRoadFloodProne] = useState(false);
  const [roadPotholes, setRoadPotholes] = useState(false);
  const [roadStreetVendors, setRoadStreetVendors] = useState(false);
  const [roadAccidentProne, setRoadAccidentProne] = useState(false);
  const [roadHawkers, setRoadHawkers] = useState(false);
  const [roadLit, setRoadLit] = useState(false);
  const [roadDrainage, setRoadDrainage] = useState(false);
  const [roadMaxspeed, setRoadMaxspeed] = useState('');
  const [roadCrossingType, setRoadCrossingType] = useState('');
  const [roadWidth, setRoadWidth] = useState('');
  const [roadCarriagewayAWidth, setRoadCarriagewayAWidth] = useState('');
  const [roadCarriagewayBWidth, setRoadCarriagewayBWidth] = useState('');
  const [roadSideFacilities, setRoadSideFacilities] = useState<SideFacilityFormState>(EMPTY_SIDE_FACILITIES);

  const resetRoadDetailsWidths = useCallback(() => {
    setRoadWidth('');
    setRoadCarriagewayAWidth('');
    setRoadCarriagewayBWidth('');
    setRoadCarriagewayALaneDirections([]);
    setRoadCarriagewayBLaneDirections([]);
    setRoadManualDividedLaneDirections(false);
  }, []);

  return {
    roadSurface,
    setRoadSurface,
    roadSmoothness,
    setRoadSmoothness,
    roadCarriagewayCount,
    setRoadCarriagewayCount,
    roadLanes,
    setRoadLanes,
    roadLanesForward,
    setRoadLanesForward,
    roadLanesBackward,
    setRoadLanesBackward,
    roadLaneDirections,
    setRoadLaneDirections,
    roadUsePerLaneWidths,
    setRoadUsePerLaneWidths,
    roadLaneWidthsM,
    setRoadLaneWidthsM,
    roadCarriagewayALaneWidthsM,
    setRoadCarriagewayALaneWidthsM,
    roadCarriagewayBLaneWidthsM,
    setRoadCarriagewayBLaneWidthsM,
    roadManualLaneDirections,
    setRoadManualLaneDirections,
    roadCarriagewayALaneDirections,
    setRoadCarriagewayALaneDirections,
    roadCarriagewayBLaneDirections,
    setRoadCarriagewayBLaneDirections,
    roadManualDividedLaneDirections,
    setRoadManualDividedLaneDirections,
    roadToll,
    setRoadToll,
    roadFloodProne,
    setRoadFloodProne,
    roadPotholes,
    setRoadPotholes,
    roadStreetVendors,
    setRoadStreetVendors,
    roadAccidentProne,
    setRoadAccidentProne,
    roadHawkers,
    setRoadHawkers,
    roadLit,
    setRoadLit,
    roadDrainage,
    setRoadDrainage,
    roadMaxspeed,
    setRoadMaxspeed,
    roadCrossingType,
    setRoadCrossingType,
    roadWidth,
    setRoadWidth,
    roadCarriagewayAWidth,
    setRoadCarriagewayAWidth,
    roadCarriagewayBWidth,
    setRoadCarriagewayBWidth,
    roadSideFacilities,
    setRoadSideFacilities,
    resetRoadDetailsWidths,
  };
}

export type RoadDetailsState = ReturnType<typeof useRoadDetailsState>;
